'use strict';
import {module} from '../app';

module.directive('appVersion', ['fullAppVersion', function (fullAppVersion) {
  return {
    restrict: 'E',
    link: function (scope, el, attrs) {
      el.html(`v ${fullAppVersion}`);
    }
  };
}]);



// WEBPACK FOOTER //
// ./src/scripts/directives/appVersion.js